import { NODE_TYPE_ITEM } from '../../types/nodeTypes';
import type { CatalogConfigProps } from './DefaultCatalogConfig';
import DefaultCatalogConfig, {
  IMAGE_VIEW,
  IMAGE_EDITABLE,
} from './DefaultCatalogConfig';

export default class BoxCatalogConfig extends DefaultCatalogConfig {
  constructor(props: CatalogConfigProps) {
    super(props);
    this.editable = props.isBoxEditor;
    this.allowedSources = [props.productsCatalogId];
    this.category.autoCategorisable = false;
    this.category.rename = props.isBoxEditor;
    this.category.delete = props.isGlobalMarket && props.isBoxEditor;
    this.category.comment = props.isBoxEditor;
    this.category.import = false;
    this.category.publish = props.isBoxEditor;
    this.category.hide = props.isBoxEditor;
    this.category.translation = props.isBoxEditor;
    this.category.levelRestriction = true;
    this.category.levelEditable = [1];
    this.category.image = props.isBoxEditor ? IMAGE_EDITABLE : IMAGE_VIEW;
    this.category.productImage = props.isBoxEditor ? IMAGE_EDITABLE : IMAGE_VIEW;
    this.category.publishMinDaysDelay = 0;

    if (props.isGlobalMarket && props.isBoxEditor) {
      this.category.deleteCategoryLevels = [1, 2];
    }

    this.category.redirectIdRequired = false;

    this.catalog.availableForMarkets = props.isGlobalMarket && props.isBoxEditor;
    this.catalog.translation = !props.isGlobalMarket && props.isBoxEditor;

    this.allowRanking = props.isBoxEditor;
    this.allowRankingLevels = [1, 2];
    this.newCategory = props.isBoxEditor;
    this.allowCutCategory = false;

    this.allowCopyCategory = props.isBoxEditor;
    this.moveDisabled = false;
    this.allowHoverActions = props.isBoxEditor;

    this.item.copy = false;
    this.item.remove = false;
    this.item.cut = false;

    this.canCopyNode = (node) => {
      if (node.level === 1) return false;

      return true;
    };

    this.canPaste = ({ nextParent, node }) => {
      if (!this.editable) return false;
      if (!this.allowedSources.includes(node?.catalogId)) return false;

      if (
        node?.type === NODE_TYPE_ITEM &&
        nextParent?.category?.childItemCount > 0
      ) {
        return true;
      }
      return nextParent?.level === 1;
    };
  }
}
